import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const AGREEMENTS: Record<string, { title: string; content: string[] }> = {
  disclaimer: {
    title: '免责声明',
    content: [
      '本平台（绿证通）是一个免费的绿证交易信息撮合平台，仅为供需双方提供信息发布、浏览和对接服务。',
      '平台不参与任何交易环节，包括但不限于：价格谈判、合同签订、资金结算、权属过户及争议解决。所有交易行为均由供需双方自行协商并承担相应法律责任。',
      '平台不对发布信息的真实性、准确性、完整性进行实质性审核，亦不对绿证的真实性、合规性提供任何形式的担保。用户在交易前应当自行核实对方资质及绿证的真实情况。',
      '平台不对因使用本平台服务所产生的任何直接、间接、附带、特殊或惩罚性的损失或损害承担责任。如发现虚假信息或违规行为，请通过平台渠道进行举报。',
      '本声明最终解释权归绿证通运营方所有。',
    ],
  },
  user: {
    title: '用户协议',
    content: [
      '欢迎使用绿证通平台。请您在使用平台服务前仔细阅读本协议，一旦使用即表示您同意本协议的全部条款。',
      '用户注册时须提供真实、准确的法人或企业信息，并对所发布的信息真实性、合法性承担全部责任。',
      '用户不得发布虚假、误导性信息，不得利用平台从事违法违规活动。平台有权对违规账户采取限制或封禁措施。',
      '用户在平台上发布的所有信息均视为公开信息，平台有权在合理范围内使用和展示。用户之间的通讯内容未经双方同意，平台不会主动公开。',
      '平台保留根据法律法规变化和业务发展需要修改本协议的权利。修改后的协议一经发布即生效，用户继续使用平台服务视为同意修改后的协议。',
    ],
  },
  privacy: {
    title: '隐私政策',
    content: [
      '本平台重视用户隐私保护。本隐私政策说明了我们如何收集、使用和保护您的个人信息。',
      '我们收集的信息包括：您在注册时提供的企业名称、联系人、联系方式等基本信息；您在平台上的发布、浏览和交易记录；以及为优化服务而自动收集的设备信息和操作日志。',
      '您的个人信息将仅用于：（1）提供和优化平台服务；（2）促进供需双方的信息匹配和对接；（3）满足法律法规要求的合规义务。我们不会将您的个人信息出售给第三方。',
      '我们采取合理的技术手段和管理措施保护您的个人信息安全，防止未经授权的访问、使用和泄露。',
      '您有权访问、更正或删除您的个人信息。如对本隐私政策有任何疑问或要求，请通过平台公示的联系方式与我们取得联系。',
    ],
  },
  publish: {
    title: '信息发布规范',
    content: [
      '为维护平台信息质量和交易秩序，所有用户在发布信息时须遵守以下规范：',
      '信息发布应当真实、准确、完整。不得发布与绿证交易无关的信息，不得重复发布相同或高度相似的信息。',
      '供给信息应包含但不限于：绿证类型、数量、年份、项目信息、交易方式和价格信息。需求信息应明确采购要求、数量和预算范围。',
      '禁止发布涉及国家机密、商业秘密的信息；禁止发布侮辱、诽谤、歧视等违法违规内容；禁止利用平台进行欺诈、传销等违法活动。',
      '平台对发布的信息进行事后审查。对违反本规范的信息，平台有权采取包括但不限于限期整改、下架信息、封禁账号等措施。',
      '用户应确保拥有所发布信息的合法权利，不得侵犯他人的知识产权、商业秘密或其他合法权益。',
    ],
  },
};

export default function AgreementPage() {
  const { type } = useParams<{ type: string }>();
  const agreement = AGREEMENTS[type || ''];

  if (!agreement) {
    return (
      <>
        <Navbar />
        <main className="w-full bg-background-50 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <p className="text-foreground-500">未找到相关协议</p>
            <Link to="/" className="inline-block mt-3 text-primary-600 text-sm hover:underline cursor-pointer">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="w-full bg-background-50 min-h-screen">
        <div className="bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <Link to="/" className="inline-flex items-center gap-1 text-foreground-500 text-sm hover:text-foreground-700 transition-colors cursor-pointer mb-4">
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              {agreement.title}
            </h1>
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-4 md:px-6 py-10">
          <div className="space-y-6">
            {agreement.content.map((paragraph, idx) => (
              <p key={idx} className="text-foreground-700 text-sm leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}